import React, {Fragment, useLayoutEffect} from 'react'
import ELEMENT from './ELEMENT'
import style from '../css/CANVAS4.module.css'
import { useTranslation } from 'react-i18next';

function isArray(obj)
{
    return obj !== undefined && obj !== null && obj.constructor == Array;
}

function isObject(obj)
{
    return obj !== undefined && obj !== null && obj.constructor == Object;
}

const ELEMENTS = (props) => {
    var isSubformInPage = props?.isSubformInPage || false;
    const data = props.data;
    const device=props.device;
    const containerId= props.containerId || "default";
    var isEmpty = true;
    const { t } = useTranslation();
    // //console.log('ELEMENTS got data :: '+JSON.stringify(data));
    // console.log('isArray :: data.children? ', data);

    if(data?.length>0){
        // console.log('isArray :: data.children? ', data);
        if(isArray(data)){
            // //console.log('data children length :: '+data.length);
        }
        isEmpty = false;
        // //console.log('isObject :: data.children? '+isObject(data));

    } else {
        isEmpty = true;
        // //console.log(' EMPTY array!!');
    }
     
    //console.log('ELEMENTS previewmode :: '+props.previewmode);
    if(props.previewmode){
        return (
            <>
            {
                !isEmpty?
                data &&  data.map(
                    (child , index) => {
                        
                        if(child.elem_type==='row'){
                            return <ELEMENT 
                                key={child.id} 
                                isSubForm={props?.isSubForm || false}
                                buttonId={props.buttonId}
                                data={child}  
                                row_id={props?.row_id}
                                tabsheetId={props?.tabsheetId}
                                isSubformInPage={isSubformInPage}
                                parentframeId={props.parentframeId}  
                                 isParentOfTab={props.isParentOfTab}         
                                 stepName={props?.stepName} 
                                 sectionStyle={props?.sectionStyle} 
                                 wizardStepIndex = {props?.wizardStepIndex}    
                                 wizardSubStepIndex = {props?.wizardSubStepIndex}   
                                 wizardStepName={props?.wizardStepName} wizardSubStepName = {props?.wizardSubStepName}         
                                // onDrop={(event)=>props.drop_prop(event)} 
                                // onDragOver={(event)=>props.allowdrop_prop(event)}
                                row_index={index}
                                device={props.device}
                                sheetName={props.sheetName}
                                stepIndex = {props?.stepIndex}
                                substepIndex={props?.substepIndex}
                                subChildMenuIndex={props?.subChildMenuIndex}
                                // drop_prop={(event)=>props.drop_prop}
                                // allowdrop_prop={(event)=>props.allowdrop_prop}
                                // handleSelected={props.handleSelected} setDragging={props.setDragging} handleReorderStart={props.handleReorderStart}  selected={props.selected} setSelected={props.setSelected} handleReorderDrop={props.handleReorderDrop}
                                frameindex={props.frameIndex}
                                elementIndex={props.elementIndex}
                                sheetIndex={props.sheetIndex}
                                sheetElementIndex={props.sheetElementIndex}
                                subStepIndex={props?.subStepIndex}
                                subStepName = {props?.subStepName}
                                previewmode={props.previewmode}
                                containerId={props.containerId}
                                ReadOnlyStyle={props.ReadOnlyStyle}
                                />
                        } else {
                            return <ELEMENT key={child.id} data={child}
                                    row_id={props?.row_id}
                                    isSubForm={props?.isSubForm || false}
                                    buttonId={props.buttonId}
                                    parentframeId={props.parentframeId}  
                                    isSubformInPage={isSubformInPage}
                                     isParentOfTab={props.isParentOfTab}   
                                     subStepIndex={props?.subStepIndex}
                                subStepName = {props?.subStepName}
                                sectionStyle={props?.sectionStyle}
                                    // onDrop={(event)=>props.drop_prop(event)} 
                                    // onDragOver={(event)=>props.allowdrop_prop(event)}
                                    device={props.device}
                                    stepIndex = {props?.stepIndex}
                                    substepIndex={props?.substepIndex}
                                    subChildMenuIndex={props?.subChildMenuIndex}
                                    wizardStepIndex = {props?.wizardStepIndex}    
                                 wizardSubStepIndex = {props?.wizardSubStepIndex}   
                                    // drop_prop={(event)=>props.drop_prop}
                                    // allowdrop_prop={(event)=>props.allowdrop_prop}
                                    // handleSelected={props.handleSelected} setDragging={props.setDragging} handleReorderStart={props.handleReorderStart}  selected={props.selected} setSelected={props.setSelected} handleReorderDrop={props.handleReorderDrop}
                                    frameindex={props.frameIndex}
                                    elementIndex={props.elementIndex}
                                    stepName={props?.stepName}
                                    sheetIndex={props.sheetIndex}
                                    sheetElementIndex={props.sheetElementIndex}
                                    sheetName={props.sheetName}
                                    previewmode={props.previewmode}
                                    containerId={props.containerId}
                                    ReadOnlyStyle={props.ReadOnlyStyle}
                                    wizardStepName={props?.wizardStepName} wizardSubStepName = {props?.wizardSubStepName}
                                    arrIndex={index}
                                    openCanvasForSubform={props.openCanvasForSubform}
                                    />
                        }
                    }
                )
                :
                null
                // <span id={props.control_id+'_highlight_me'} className={style.emptyControl} elem_type={props.elem_type} control_id={props.control_id} frameindex={props.frameIndex}>{props.elem_type}</span>
            }
                
            </>
        );

    } 
    else {
        return (
            <>
            {
                !isEmpty?
                data &&  data.map(
                    (child , index) => {
                        
                        if(child?.elem_type==='row'){                        
    
                                return <ELEMENT 
                                    row_id={props?.row_id}
                                    isSubForm={props?.isSubForm || false}
                                    buttonId={props.buttonId}
                                    tabsheetId={props?.tabsheetId}
                                    key={child?.id} 
                                    data={child}  
                                    sectionStyle={props?.sectionStyle}
                                    isSubformInPage={isSubformInPage}   
                                    stepName={props?.stepName}                        // onDrop={(event)=>props.drop_prop(event)} 
                                    wizardStepIndex = {props?.wizardStepIndex}    
                                 wizardSubStepIndex = {props?.wizardSubStepIndex}   
                                 subStepIndex={props?.subStepIndex}
                                subStepName = {props?.subStepName}
                                    // onDragOver={(event)=>props.allowdrop_prop(event)}
                                    parentframeId={props.parentframeId}  
                                    stepIndex = {props?.stepIndex}
                                    substepIndex={props?.substepIndex}
                                    subChildMenuIndex={props?.subChildMenuIndex}
                                    wizardStepName={props?.wizardStepName} wizardSubStepName = {props?.wizardSubStepName}
                                    isParentOfTab={props.isParentOfTab}     
                                    containerId={props.containerId}
                                    row_index={index}
                                    device={props.device}
                                    drop_prop={(event)=>props.drop_prop}
                                    allowdrop_prop={(event)=>props.allowdrop_prop}
                                    handleSelected={props.handleSelected} setDragging={props.setDragging} handleReorderStart={props.handleReorderStart}  setSelected={props.setSelected} handleReorderDrop={props.handleReorderDrop}
                                    handleDragLeave={props?.handleDragLeave}
                                    frameindex={props.frameIndex}
                                    elementIndex={props.elementIndex}
                                    sheetIndex={props.sheetIndex}
                                    sheetName={props.sheetName}
                                    sheetElementIndex={props.sheetElementIndex}
                                    ReadOnlyStyle={props.ReadOnlyStyle}
                                    />
                            
                        } else {
                            return <ELEMENT key={child?.id} data={child}
                                    row_id={props?.row_id}
                                    isSubForm={props?.isSubForm || false}
                                    buttonId={props.buttonId}
                                    sectionStyle={props?.sectionStyle}
                                    parentframeId={props.parentframeId}  
                                    isSubformInPage={isSubformInPage}
                                    onDrop={(event)=>props.drop_prop(event)} 
                                    onDragOver={(event)=>props.allowdrop_prop(event)}
                                    containerId={props.containerId}
                                    isParentOfTab={props.isParentOfTab}     
                                    device={props.device}
                                    stepIndex = {props?.stepIndex}
                                    substepIndex={props?.substepIndex}
                                    subChildMenuIndex={props?.subChildMenuIndex}
                                    wizardStepName={props?.wizardStepName} wizardSubStepName = {props?.wizardSubStepName}
                                    // drop_prop={(event)=>props.drop_prop}
                                    // allowdrop_prop={(event)=>props.allowdrop_prop}
                                    handleSelected={props.handleSelected} setDragging={props.setDragging} handleReorderStart={props.handleReorderStart}  setSelected={props.setSelected} handleReorderDrop={props.handleReorderDrop}
                                    handleDragLeave={props?.handleDragLeave}
                                    frameindex={props.frameIndex}
                                    elementIndex={props.elementIndex}
                                    stepName={props?.stepName}
                                    sheetIndex={props.sheetIndex}
                                    wizardStepIndex = {props?.wizardStepIndex}    
                                 wizardSubStepIndex = {props?.wizardSubStepIndex}   
                                    sheetElementIndex={props.sheetElementIndex}
                                    subStepIndex={props?.subStepIndex}
                                subStepName = {props?.subStepName}
                                    hasParentOfTab={props.hasParentOfTab}
                                    sheetid={props.sheetid} 
                                    tabParentId={props.tabParentId} 
                                    sheetName={props.sheetName}
                                    ReadOnlyStyle={props.ReadOnlyStyle}
                                    dragId={props.dragId}
                                    arrIndex={index}
                                    openCanvasForSubform={props.openCanvasForSubform}
                                    />
                        }
                    }
                )
                :
                <div id={props.control_id+'_highlight_me'} className={style.emptyControl} elem_type={props.elem_type} control_id={props.control_id} frameindex={props.frameIndex}
                sheetElementIndex={props.sheetElementIndex} sheetIndex={props.sheetIndex}
                style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%, -50%)"}}
                >
                    {props.elem_type ? t(`translation:${props?.elem_type}`) : props?.elem_type }
                </div>
            }
                
            </>
        );

    }
}

export default ELEMENTS